import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
    status: {
        summary: '',
        months: '',
        pdfDownload: '',
        bulkLatestMonth: '',
        bulkRequest: '',
        bulkJobs: ''
    },
    summary: [],
    months: [],
    selectedYear: null,
    // 일괄 다운로드
    bulkLatestMonth: null,
    // 요청 화면 안내에 쓰는 제약값. 전부 서버가 내려준다(프론트 상수 금지 — BO-964).
    bulkRequestInfo: {
        mailAttachLimitBytes: null,
        expireDays: null
    },
    bulkJobs: []
}

export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations
}
